
export type ConfirmationType =
    'CreateUser' |
    'ChangeEmail' |
    'ResetPassword' |
    'PortalMagicLinkLogin';

export type CreateUserRequestConfirmationData = 
{
    typeName:'CreateUser',
    userId:string,
    firstname:string,
    middlename:string,
    lastname:string,
    email:string,
    passwordHash:string,
    passwordSalt:string
};
export type NewEmailRequestConfirmationData = {
    typeName:'ChangeEmail',
    newEmail:string;
}
export type ResetPasswordRequestConfirmationData = {
    typeName:'ResetPassword',
    subtype:'ForgotPassword' | 'SetupPassword',
};

export type PortalMagicLinkLoginRequestData = {
    typeName:'PortalMagicLinkLogin',
    email:string
}

export type ConfirmationRequestData =
    CreateUserRequestConfirmationData | 
    NewEmailRequestConfirmationData | 
    ResetPasswordRequestConfirmationData |
    PortalMagicLinkLoginRequestData;

export class ConfirmationRequest{
    constructor(
        public id:string,
        public identifier:string, /* typically userId */
        public data: ConfirmationRequestData,
        public created:Date
    ){}
}

